export const surround =
  <Before extends string, After extends string>(surrounder: [Before, After]) =>
  <T extends string>(str: T): `${Before}${T}${After}` => {
    const [before, after] = surrounder
    return `${before}${str}${after}`
  }
